import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  input,
  output,
  signal,
  TemplateRef,
} from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

const AUTO_CLOSE_DELAY_MS = 900;

@Component({
  selector: 'tmx-profile-dropdown',
  standalone: true,
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.scss'],
  imports: [NgClass, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileDropdownComponent {
  private timeoutId: unknown;
  private keepOpen = false;
  isOpen = signal(false);
  profileImageLoaded = signal(true);

  dropdownTooltip = input<string | TemplateRef<unknown>>('Profile');
  ariaLabel = input('profile');
  profileImageSource = input('');
  firstName = input<string>('');
  lastName = input<string>('');
  email = input<string>('');
  disabled = input(false);
  closeAutomatically = input(true);
  signOutButtonText = input('Sign Out');
  appVersionText = input<string>();

  signOutClicked = output();

  initials = computed(
    () =>
      `${this.firstName()[0].toUpperCase()}${this.lastName()[0].toUpperCase()}`
  );

  @HostListener('document:click')
  clickOutside() {
    if (this.keepOpen) {
      this.keepOpen = false;
    } else {
      this.isOpen.set(false);
    }
  }

  @HostListener('click')
  clickInside() {
    this.keepOpen = true;
  }

  signOut() {
    this.signOutClicked.emit();
  }

  closeMenuAutomatically() {
    const isOpen = this.isOpen();
    if (isOpen && this.closeAutomatically()) {
      this.timeoutId = setTimeout(() => {
        this.isOpen.set(false);
      }, AUTO_CLOSE_DELAY_MS);
    }
  }

  cancelCloseMenuAutomatically() {
    if (typeof this.timeoutId === 'number') {
      clearTimeout(this.timeoutId);
    }
  }

  handleImageLoaded() {
    this.profileImageLoaded.set(true);
  }
  handleImageLoadError() {
    this.profileImageLoaded.set(false);
  }
}
